export default __webpack_public_path__ + "static/media/peary_prairie.4e281ae7.svg";